import { render, staticRenderFns } from "./IngredientsViewer.vue?vue&type=template&id=7e792698&scoped=true&"
import script from "./IngredientsViewer.vue?vue&type=script&lang=js&"
export * from "./IngredientsViewer.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsViewer.vue?vue&type=style&index=0&id=7e792698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e792698",
  null
  
)

export default component.exports